// Lib
import React from 'react';
import { Typography, FormControlLabel, Radio, RadioGroup } from '@mui/material';

// Components
import Button from '../../../Button';

// Hooks
import useAddressFormat from '../../../../pages/AddressBook/hooks/useAddressFormat';

// Styles
import { useStyles } from './AddressFormatStyles';

const AddressFormat = ({
  afterValidation: {
    original_address: originalAddress,
    validated_address: validatedAddress,
  },
  formData,
  editMode,
  onBackToForm,
}) => {
  const { classes } = useStyles();
  const { onSave, onChangeFormat, selectedAddress, apiError } =
    useAddressFormat(formData, editMode);

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h2">
        Select Address Format
      </Typography>
      <RadioGroup
        className={classes.radioGroup}
        defaultValue={selectedAddress}
        row={false}
        aria-labelledby="address-format-radio-buttons-group-label"
        name="address-format-radio-buttons-group">
        <div className={classes.text}>Entered Address</div>
        <FormControlLabel
          className={classes.formControlLabel}
          value="original_address"
          control={<Radio onChange={onChangeFormat} />}
          label={originalAddress}
        />
        {validatedAddress && (
          <>
            <div className={classes.text}>Validated Address</div>
            <FormControlLabel
              className={classes.formControlLabel}
              value="validated_address"
              control={<Radio onChange={onChangeFormat} />}
              label={validatedAddress}
            />
          </>
        )}
      </RadioGroup>
      {apiError && <p className={classes.accent}>{apiError}</p>}
      <div className={classes.buttonContainer}>
        <Button className={classes.transparentButton} onClick={onBackToForm}>
          Back
        </Button>
        <Button onClick={onSave}>Save</Button>
      </div>
    </div>
  );
};

export default AddressFormat;
